import React from 'react'
import { useQuery } from 'react-query';
import { GetCacheKey, getItemOfSessionStorage } from '../../../services/common/utils';
import Loadingcomponent from '../../../components/loader/loadingcomponent';
import ErrorMessage from '../../../components/messaging/errormessage';
import {Link, useNavigate} from "react-router-dom";
import {redirecturl} from '../../../services/common/redirect';
import { SELECTED_LANG } from '../../../services/common/Constants';
import useCheckMobileScreen from '../../../hooks/useCheckMobileScreen';

function PromotionsContent({psmItem}) {
    const lang = getItemOfSessionStorage(SELECTED_LANG);
    const { isMobile } = useCheckMobileScreen();
    const {
        data: { data } = {},
        isLoading,
        error,
        isFetching,
        isError,
        isLoadingError,
      } = useQuery(
        [
          GetCacheKey(psmItem?.uniqueid),
          psmItem?.method,
          JSON.parse(psmItem?.sourceid),
          {},
        ],
        {
          retry: false,
          retryOnMount: false,
          cacheTime: 0,
          staleTime: 0,
        }
      );
    const navigate = useNavigate();
    const handleRedirect = (url) =>{
      if(url?.indexOf("https://") === 0){
          window.open(url, "_blank");
      }else{
          redirecturl(url, navigate)
      }
    }
      if (isLoading || isFetching) {
        return <Loadingcomponent message={'Loading'} />;
      }
    
      if (error || isError || isLoadingError) {
        return <ErrorMessage message={'Invalid'} />;
      }
  return (
    <div class="promo-detail-pg mt-4">
      <div class="promo-cards gap-2 d-flex justify-content-between align-item-center">
        {data?.response?.[0]?.banners?.map((item, index) =>(
           <div class={`promo-card ${isMobile ? index === 0 ? '' : 'mt-2' : ''}`}>
            <Link onClick={()=> handleRedirect(item?.url)}><img 
            //src={item?.path}
             src={`${item?.path + '?tmp=' + 't' + Date.now()}`}
            ></img></Link>
          </div>
        ))}
      </div>
    </div>
    
  )
}

export default PromotionsContent
